import { deconstructEncryptedPayloadString } from '../../V004AlgorithmHelpers';
import { ParseConsistentBase64JsonPayloadUseCase } from '../Utils/ParseConsistentBase64JsonPayload';
export class GetPayloadAuthenticatedDataDetachedUseCase {
    constructor(crypto) {
        this.crypto = crypto;
        this.parseStringUseCase = new ParseConsistentBase64JsonPayloadUseCase(this.crypto);
    }
    execute(encrypted) {
        const contentKeyComponents = deconstructEncryptedPayloadString(encrypted.enc_item_key);
        const authenticatedDataString = contentKeyComponents.authenticatedData;
        const result = this.parseStringUseCase.execute(authenticatedDataString);
        return result;
    }
}
